export default __webpack_public_path__ + "static/media/delete.03ab35eb.svg";